export const BASE_RESPONSIVE_TOOLBAR_COLORS = {
  HANDLE_BUTTON_BACKGROUND_ACTIVE: '#00a4bd',
  // Calypso - fill-info-default
  HANDLE_BUTTON_BACKGROUND_INACTIVE: '#99acc2',
  // Flint - text-core-disabled
  HANDLE_BUTTON_TEXT_COLOR: '#ffffff',
  // Olaf - text-core-on-fill-default
  ICON_BUTTON_BORDER_ACTIVE: '#425b76',
  // Heffalump - fill-accent-neutral-default
  ICON_BUTTON_BORDER_INACTIVE: '#cbd6e2',
  // BATTLESHIP - fill-tertiary-pressed
  ICON_BUTTON_BORDER_HOVER: '#516f90' // Slinky - fill-accent-neutral-hover
};